import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
const rotatingTexts = [
  "Post Your Property for Free",
  "List Your Home in Minutes",
  "Reach Thousands of Buyers",
  "Sell or Rent Without Fees",
  "Showcase Your Property Today",
];

const RotatingText = () => {
  const [index, setIndex] = useState(0);
const MotionBox = motion.create(Box);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % rotatingTexts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <AnimatePresence mode="wait">
      <MotionBox
  key={rotatingTexts[index]}
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  exit={{ opacity: 0, y: -20 }}
  transition={{ duration: 0.6 }}
  sx={{
    fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2rem" },
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 600,
    textAlign: "center",
    color: "#fff",
    minHeight: "3rem",
    textShadow: "0px 1px 4px rgba(0, 0, 0, 0.3)",
  }}
>
  {rotatingTexts[index]}
</MotionBox>
    </AnimatePresence>
  );
};

export default RotatingText;
